import React, { useEffect } from 'react';
import { Grid, Typography, makeStyles, Box } from '@material-ui/core';
import { PropertyFormStore } from '../../../stores/properties/propertyFormStore';
import {
  notLicensedinState,
  propertyCitiesRestriction,
  statePropertyTypeRestriction,
  floridaCountiesRestriction
} from '@roc/feature-utils';
import { observer } from 'mobx-react-lite';
import { Error } from '@material-ui/icons';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';
import { isRestrictedCounty } from '../../../utils/utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: '#FFF4E5',
    borderRadius: '8px',
    marginTop: '16px',
    padding: '14px 16px',
    alignItems: 'center',
  },
  icon: {
    color: '#EF6C00',
    marginRight: '12px',
  },
  title: {
    fontWeight: 'bold',
    color: '#663C00',
  },
  description: {
    color: '#1E4620',
  },
}));

interface Props {
  store: PropertyFormStore;
  quoteTypeStore: QuoteTypeStore;
}

export const PropertyAddressMessages = observer(
  ({ store, quoteTypeStore }: Props) => {
    const state = store.form.fields.state.value;
    const city = store.form.fields.city.value;
    const propertyType = store.form.fields.propertyType.value;
    const isAppraisalAvailable = !!store.form.fields.isAppraisalAvailable.value;
    const notLicensedState = notLicensedinState.states.includes(state);

    useEffect(() => {
      store.checkLicenseRequired(state);
    }, [state]);
    const isFloridaCondo =
      statePropertyTypeRestriction.states.includes(state) &&
      statePropertyTypeRestriction.propertyTypes.includes(propertyType);
    const isRestrictedBaltimoreCity = propertyCitiesRestriction.cities.includes(city?.trim().toLowerCase()) && store.isValidLoanSubtypeForCityRestrictions

    const countyValue = store.form.fields.county.value?.trim().toLowerCase();
    const isRestrictedFloridaCounty = isRestrictedCounty(countyValue, floridaCountiesRestriction.counties, state, floridaCountiesRestriction.states);
    return (
      <>
        {notLicensedState && <NotLicensedInState />}
        {store.stateLicenseMessage && <StateLicenseMatrixMessage message={store.stateLicenseMessage} />}
        {isAppraisalAvailable && <AppraisalAvailable />}
        {isFloridaCondo && <IsFloridaCondo />}
        {isRestrictedBaltimoreCity && <IsRestrictedBaltimoreCity />}
        {isRestrictedFloridaCounty && <IsRestrictedFloridaCounty />}
      </>
    );
  }
);

const NotLicensedInState = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={{ backgroundColor: '#FDEDED' }}>
      <ErrorOutlineIcon className={classes.icon} style={{ color: '#D32F2F' }} />
      <Typography
        className={classes.title}
        variant="body1"
        style={{ color: '#5F2120' }}
      >
        {notLicensedinState.message}
      </Typography>
    </Box>
  );
};

const StateLicenseMatrixMessage = ({ message }: { message: string }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={{ backgroundColor: '#FDEDED' }}>
      <ErrorOutlineIcon className={classes.icon} style={{ color: '#D32F2F' }} />
      <Typography
        className={classes.title}
        variant="body1"
        style={{ color: '#5F2120' }}
      >
        {message}
      </Typography>
    </Box>
  );
};


const AppraisalAvailable = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={{ backgroundColor: '#EDF7ED' }}>
      <CheckCircleOutlineIcon
        className={classes.icon}
        style={{ color: '#2E7D32' }}
      />
      <Typography
        className={classes.title}
        variant="body1"
        style={{ color: '#1E4620' }}
      >
        Appraisal Available
      </Typography>
    </Box>
  );
};

const IsFloridaCondo = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={{ backgroundColor: '#FDEDED' }}>
      <ErrorOutlineIcon className={classes.icon} style={{ color: '#D32F2F' }} />
      <Typography
        className={classes.title}
        variant="body1"
        style={{ color: '#5F2120' }}
      >
        {statePropertyTypeRestriction.message}
      </Typography>
    </Box>
  );
};

const IsRestrictedBaltimoreCity = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={{ backgroundColor: '#FDEDED' }}>
      <ErrorOutlineIcon className={classes.icon} style={{ color: '#D32F2F' }} />
      <Typography
        className={classes.title}
        variant="body1"
        style={{ color: '#5F2120' }}
      >
        {propertyCitiesRestriction.message}
      </Typography>
    </Box>
  );
};

const IsRestrictedFloridaCounty = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root} style={{ backgroundColor: '#FDEDED' }}>
      <ErrorOutlineIcon className={classes.icon} style={{ color: '#D32F2F' }} />
      <Typography
        className={classes.title}
        variant="body1"
        style={{ color: '#5F2120' }}
      >
        {floridaCountiesRestriction.message}
      </Typography>
    </Box>
  );
};
